import React, { useEffect, useState } from 'react'
import { Row, Card, Form, Input, Radio, Space, Button, Col, Typography } from 'antd'
import InputMask from 'react-input-mask'
import { EmptyHeaderHero, GlobalHeader, GlobalFooter } from './components'
import { sendEmailForExpressPolicyChanges } from '../services'
import { REMOVE_DRIVER_JSON_MAP } from './RemoveDriverConstants'

import RemoveDriverStyle from '../../styles/RemoveDriver.module.css'
import { NoIndex } from './NoIndex'

const { Text } = Typography
const { TextArea } = Input
const reasonObj = {
  no_policy_vechicles: 'No longer drives policy vehicles',
  no_householder: 'No longer resides in household and does not have access to vehicles insured on this policy',
  own_car: 'Obtained own car and own insurance',
  no_valid_license: "No longer has a valid driver's license"
}

const arr = ['no_policy_vechicles', 'no_householder', 'own_car', 'no_valid_license']
const RemoveDriver = () => {
  useEffect(() => {
    window.location.href = "/404";
  }, []);

  return null;

  const [driver, setDriver] = useState({
    firstName: '',
    lastName: '',
    policyNumber: '',
    phoneNumber: '',
    streetAddress: '',
    zipCode: '',
    emailAddress: '',
    removeDriverInfo: {
      firstName: '',
      lastName: '',
      dateOfBirth: '',
      reason: '',
      otherOption: '',
      explanation: '',
      effectDate: ''
    }
  })
  const [disableButton, setDisableButton] = useState(false)

  const validateBasicFormData = driverInfo => {
    const {
      firstName,
      lastName,
      policyNumber,
      phoneNumber,
      streetAddress,
      zipCode,
      emailAddress,
      removeDriverInfo: { firstName: fName, lastName: lName, dateOfBirth, reason, otherOption, explanation, effectDate }
    } = driverInfo

    if (
      firstName &&
      lastName &&
      policyNumber &&
      phoneNumber &&
      streetAddress &&
      zipCode &&
      emailAddress &&
      fName &&
      lName &&
      dateOfBirth &&
      reason &&
      effectDate
    ) {
      if (reason === 'no_policy_vechicles') {
        if (otherOption) {
          return { isValid: true }
        } else {
          return { isValid: false }
        }
      } else if (reason === 'no_valid_license') {
        if (explanation) {
          return { isValid: true }
        } else {
          return { isValid: false }
        }
      } else {
        return { isValid: true }
      }
    } else {
      return { isValid: false }
    }
  }

  const validateDate = driverInfo => {
    const {
      removeDriverInfo: { dateOfBirth, effectDate }
    } = driverInfo

    if (new Date(dateOfBirth).toString() === 'Invalid Date' || new Date(effectDate).toString() === 'Invalid Date') {
      return { isValid: false }
    } else {
      return { isValid: true }
    }
  }

  const validateEmail = driverInfo => {
    const { emailAddress } = driverInfo
    const regEx = /\S+@\S+\.\S+/

    if (emailAddress.length > 0 && regEx.test(emailAddress)) {
      return { isValid: true }
    } else {
      return { isValid: false }
    }
  }

  const validateZipCode = driverInfo => {
    const { zipCode } = driverInfo

    if (zipCode.length < 5) {
      return { isValid: false }
    } else {
      return { isValid: true }
    }
  }

  const formatPhoneNumber = phoneNumber => {
    const USNumber = phoneNumber.match(/(\d{3})(\d{3})(\d{4})/)
    return USNumber ? `(${USNumber?.[1]}) ${USNumber?.[2]}-${USNumber?.[3]}` : ''
  }

  const validatePhoneNumber = driverInfo => {
    const { phoneNumber } = driverInfo
    const updatedNumber = phoneNumber.replace(/[^\w\s]/gi, '').replace(' ', '')
    if (formatPhoneNumber(updatedNumber).length < 10) {
      return { isValid: false }
    } else {
      return { isValid: true }
    }
  }

  const validateFields = driverInfo => {
    let validationResponse = true
    const initialResponse = validateBasicFormData(driverInfo)
    if (initialResponse.isValid) {
      const dateValidationResponse = validateDate(driverInfo)
      const emailValidationResponse = validateEmail(driverInfo)
      const zipCodeValidationResponse = validateZipCode(driverInfo)
      const phoneValidationResponse = validatePhoneNumber(driverInfo)
      if (
        dateValidationResponse.isValid &&
        emailValidationResponse.isValid &&
        zipCodeValidationResponse.isValid &&
        phoneValidationResponse.isValid
      ) {
        validationResponse = true
      } else {
        validationResponse = false
      }
    } else {
      validationResponse = false
    }
    return validationResponse
  }

  const stripFinalJson = driverInfo => {
    const {
      firstName,
      lastName,
      policyNumber,
      phoneNumber,
      streetAddress,
      zipCode,
      emailAddress,
      removeDriverInfo: {
        firstName: removeDriverInfoFirstName,
        lastName: removeDriverInfoLastName,
        dateOfBirth,
        reason,
        otherOption,
        explanation,
        effectDate
      }
    } = driverInfo

    const obj = {
      firstName,
      lastName,
      policyNumber,
      phoneNumber,
      streetAddress,
      zipCode,
      emailAddress,
      removeDriverInfo: {
        firstName: removeDriverInfoFirstName,
        lastName: removeDriverInfoLastName,
        dateOfBirth,
        reason,
        ...(reason === 'no_policy_vechicles' && {
          otherOption
        }),
        ...(reason === 'no_valid_license' && {
          explanation
        }),
        effectDate
      }
    }
    return obj
  }

  const buildTable = driverInfo => {
    var table = '<table border="1">'
    table += '<tr><td colspan="2"><b>Policyholder Information</b></td></tr>'
    for (const key in driverInfo) {
      if (driverInfo[key] instanceof Object) {
        table += '<tr><td colspan="2"><b>Remove Driver Information</b></td></tr>'
        for (const additionalKey in driverInfo[key]) {
          if (arr.includes(driverInfo[key][additionalKey])) {
            table += `<tr><td>${REMOVE_DRIVER_JSON_MAP[key][additionalKey]}</td><td>${reasonObj[driverInfo[key][additionalKey]]
              }</td></tr>`
          } else {
            table += `<tr><td>${REMOVE_DRIVER_JSON_MAP[key][additionalKey]}</td><td>${driverInfo[key][additionalKey]}</td></tr>`
          }
        }
      } else {
        table += `<tr><td>${REMOVE_DRIVER_JSON_MAP[key]}</td><td>${driverInfo[key]}</td></tr>`
      }
    }
    table += '</table>'
    return table
  }

  const handleSubmit = async () => {
    setDisableButton(true)
    const finalJson = stripFinalJson(driver)
    const htmlText = buildTable(finalJson)
    const mailObj = {
      subject: `[Remove Driver] - ${driver.policyNumber}`,
      content: htmlText
    }
    localStorage.setItem('expressPolicyChangeType', 'Remove Driver')

    await sendEmailForExpressPolicyChanges(mailObj)

    const newWindow = window.open('/g/express-policy-changes/result', '_self', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  const updateUserTextFields = (text, field) => {
    const clonedUser = { ...driver }
    clonedUser[field] = text
    setDriver(clonedUser)
  }

  const buttonStatus = !validateFields(driver) || disableButton

  return (
    <div className="container">
      <NoIndex/>
      <GlobalHeader />
      <>
        <EmptyHeaderHero minHeight={true} title="Remove Driver" />
        <div className={`${RemoveDriverStyle["remove-driver"]}`}>
          <p className={`${RemoveDriverStyle["disclaimer"]}`}>Once your change request has been approved and processed, you will be sent updated policy documents and billing schedule.</p>
          <Row>
            <Card className={`${["register-card"]}`}>
              <h5 className={`${RemoveDriverStyle["sub-label"]}`}>Policyholder Information</h5>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveDriverStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${RemoveDriverStyle["input-text"]}`}
                      onChange={event => { updateUserTextFields(event.target.value, "firstName") }}
                      placeholder="First Name*"
                      value={driver.firstName}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveDriverStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${RemoveDriverStyle["input-text"]}`}
                      onChange={event => { updateUserTextFields(event.target.value, "lastName") }}
                      placeholder="Last Name*"
                      value={driver.lastName}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveDriverStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${RemoveDriverStyle["input-text"]}`}
                      onChange={event => { updateUserTextFields(event.target.value, "policyNumber") }}
                      placeholder="Policy Number*"
                      value={driver.policyNumber}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveDriverStyle["margin-bottom-14"]}`}>
                    <InputMask
                      className={`${RemoveDriverStyle["input-text"]} ${RemoveDriverStyle["phone-number"]}`}
                      mask="(999) 999-9999"
                      onChange={event => { updateUserTextFields(event.target.value, "phoneNumber") }}
                      placeholder="Phone Number*"
                      value={driver.phoneNumber}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveDriverStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${RemoveDriverStyle["input-text"]}`}
                      onChange={event => {
                        setDriver({
                          ...driver,
                          streetAddress: event.target.value
                        })
                      }}
                      placeholder="Street Address*"
                      value={driver.streetAddress}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveDriverStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${RemoveDriverStyle["input-text"]}`}
                      maxLength={5}
                      onChange={event => {
                        setDriver({
                          ...driver,
                          zipCode: event.target.value.replace(/\D/g, '')
                        })
                      }}
                      placeholder="Zip Code*"
                      value={driver.zipCode}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveDriverStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${RemoveDriverStyle["input-text"]}`}
                      onChange={event => { updateUserTextFields(event.target.value, "emailAddress") }}
                      placeholder="Email Address*"
                      value={driver.emailAddress}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <h5 className={`${RemoveDriverStyle["sub-label"]}`}>Remove Driver Information</h5>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveDriverStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${RemoveDriverStyle["input-text"]}`}
                      onChange={event => {
                        const removeDriverInfo = {
                          ...driver.removeDriverInfo,
                          firstName: event.target.value
                        }
                        setDriver({
                          ...driver,
                          removeDriverInfo
                        })
                      }}
                      placeholder="First Name*"
                      value={driver.removeDriverInfo.firstName}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveDriverStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${RemoveDriverStyle["input-text"]}`}
                      onChange={event => {
                        const removeDriverInfo = {
                          ...driver.removeDriverInfo,
                          lastName: event.target.value
                        }
                        setDriver({
                          ...driver,
                          removeDriverInfo
                        })
                      }}
                      placeholder="Last Name*"
                      value={driver.removeDriverInfo.lastName}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveDriverStyle["margin-bottom-14"]}`}>
                    <InputMask
                      className={`${RemoveDriverStyle["dob"]}`}
                      mask="99/99/9999"
                      onChange={event => {
                        const removeDriverInfo = {
                          ...driver.removeDriverInfo,
                          dateOfBirth: event.target.value
                        }
                        setDriver({
                          ...driver,
                          removeDriverInfo
                        })
                      }}
                      placeholder="DOB (mm/dd/yyyy)*"
                      value={driver.removeDriverInfo.dateOfBirth}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xl={{ span: 18 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveDriverStyle["margin-bottom-14"]}`}>
                    <Text className={`${RemoveDriverStyle["form-label"]}`}>Reason for Removing Driver:*</Text>
                    <Radio.Group
                      onChange={event => {
                        const removeDriverInfo = {
                          ...driver.removeDriverInfo,
                          reason: event.target.value
                        }
                        setDriver({
                          ...driver,
                          removeDriverInfo
                        })
                      }}
                      value={driver.removeDriverInfo.reason}
                    >
                      <Radio value="no_policy_vechicles">No longer drives policy vehicles.</Radio>
                      {driver.removeDriverInfo.reason === 'no_policy_vechicles' && (
                        <Row>
                          <Col className={`${RemoveDriverStyle["margin-left-24"]}`} xl={{ span: 24 }} xs={{ span: 24 }}>
                            <Form.Item className={`${RemoveDriverStyle["margin-bottom-14"]}`}>
                              <Radio.Group
                                onChange={event => {
                                  const removeDriverInfo = {
                                    ...driver.removeDriverInfo,
                                    otherOption: event.target.value
                                  }
                                  setDriver({
                                    ...driver,
                                    removeDriverInfo
                                  })
                                }}
                                value={driver.removeDriverInfo.otherOption}
                              >
                                <Radio value="no_householder">
                                  No longer resides in household and does not have access to vehicles insured on this
                                  policy.
                                </Radio>
                                <Radio value="own_car">Obtained own car and own insurance.</Radio>
                              </Radio.Group>
                            </Form.Item>
                          </Col>
                        </Row>
                      )}
                      <Radio value="no_valid_license">No longer has a valid driver&apos;s license.</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              {driver.removeDriverInfo.reason === 'no_valid_license' && (
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item className={`${RemoveDriverStyle["margin-bottom-14"]}`}>
                      <TextArea
                        autoComplete="off"
                        className={`${RemoveDriverStyle["textarea-text"]}`}
                        onChange={event => {
                          const removeDriverInfo = {
                            ...driver.removeDriverInfo,
                            explanation: event.target.value
                          }
                          setDriver({
                            ...driver,
                            removeDriverInfo
                          })
                        }}
                        placeholder="Please explain why*"
                        rows={4}
                        value={driver.removeDriverInfo.explanation}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              )}
              <Text className={`${RemoveDriverStyle["form-effect-label"]}`}>What date would you like this change to go into effect?*</Text>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${RemoveDriverStyle["margin-bottom-14"]}`}>
                    <InputMask
                      className={`${RemoveDriverStyle["dob"]}`}
                      mask="99/99/9999"
                      onChange={event => {
                        const removeDriverInfo = {
                          ...driver.removeDriverInfo,
                          effectDate: event.target.value
                        }
                        setDriver({
                          ...driver,
                          removeDriverInfo
                        })
                      }}
                      placeholder="mm/dd/yyyy*"
                      value={driver.removeDriverInfo.effectDate}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Row>
          <Row className={`${RemoveDriverStyle["submit-container"]}`}>
            <Form.Item className={`${RemoveDriverStyle["btn-control"]} ${RemoveDriverStyle["button-submit-form"]}`}>
              <Space>
                <Button className={`${RemoveDriverStyle["register"]} ${RemoveDriverStyle["register-form-button"]}`} disabled={buttonStatus} onClick={handleSubmit}>
                  Submit
                </Button>
              </Space>
            </Form.Item>
          </Row>
        </div>
      </>
      <GlobalFooter />
    </div>
  )
}

RemoveDriver.propTypes = {}

export default RemoveDriver
